import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";
import { useSyncCountry } from "@App/hooks/useSyncCountry";
import { AirConditioning } from "@App/Pages/AirConditioning";
import { Appointment } from "@App/Pages/Appointment";
import { BrakeFluidService } from "@App/Pages/BrakeFluidService";
import { BrakesService } from "@App/Pages/BrakesService";
import { Certificate } from "@App/Pages/Certificate";
import { ClutchService } from "@App/Pages/ClutchService";
import { Contact } from "@App/Pages/Common/Contact";
import { Garages } from "@App/Pages/Common/Garages";
import { Profile } from "@App/Pages/Common/Profile";
import { RedirectToCatchAll } from "@App/Pages/Common/RedirectToCatchAll";
import { Summary } from "@App/Pages/Common/Summary";
import { Glass } from "@App/Pages/Glass";
import { Inspection } from "@App/Pages/Inspection";
import { Layout } from "@App/Pages/Layout";
import { Oilchange } from "@App/Pages/Oilchange";
import { SparkPlugService } from "@App/Pages/SparkPlugService";
import { StarterBattery } from "@App/Pages/StarterBattery";
import { Timingbelt } from "@App/Pages/Timingbelt";
import { TrailerHitch } from "@App/Pages/TrailerHitch";
import { Wheelchange } from "@App/Pages/Wheelchange";
import type { State } from "@App/state";
import i18n from "@App/utils/i18n";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

export function RepareoFunnel() {
  const { navigateWithQuery } = useNavigateWithQueryParams();

  const organization = useSelector((state: State) => state.orders.organization);
  const service = useSelector((state: State) => state.orders.service);

  // change the language
  useEffect(() => {
    i18n.changeLanguage(organization?.settings?.language);
  }, []);

  // keep the date locale and the phone dial code in sync with the searched country
  useSyncCountry();

  const submitGarage = () => {
    // use the current store state to get the service
    // because the useSelector hook is not getting updated on time
    navigateWithQuery(`/${service?.slug}/werkstatt`);
  };

  const submitSlot = () => {
    // use the current store state to get the service
    // because the useSelector hook is not getting updated on time
    navigateWithQuery(`/${service?.slug}/werkstatt/buchen`);
  };

  const submitInquiry = () => {
    // use the current store state to get the service
    // because the useSelector hook is not getting updated on time
    navigateWithQuery(`/${service?.slug}/werkstatt/buchen/erfolgreich`);
  };

  return (
    <Routes>
      <Route path={"/"} element={<Layout />}>
        {/* checkout */}
        <Route path={":serviceSlug/werkstaetten"} element={<Garages onSubmit={submitGarage} />} />
        <Route path={":serviceSlug/werkstatt"} element={<Profile onSubmit={submitSlot} />} />
        <Route
          path={":serviceSlug/werkstatt/buchen"}
          element={<Contact onSubmit={submitInquiry} />}
        />
        <Route path={":serviceSlug/werkstatt/buchen/erfolgreich"} element={<Summary />} />
        {/* funnels */}
        <Route path={"inspektion/*"} element={<Inspection />} />
        <Route path={"hu-au-tuev/*"} element={<Certificate />} />
        <Route path={"bremsenwechsel/*"} element={<BrakesService />} />
        <Route path={"oelwechsel/*"} element={<Oilchange />} />
        <Route path={"kupplung/*"} element={<ClutchService />} />
        <Route path={"starterbatterie-erneuern/*"} element={<StarterBattery />} />
        <Route path={"zahnriemenwechsel/*"} element={<Timingbelt />} />
        <Route path={"autoglas-reparatur/*"} element={<Glass />} />
        <Route path={"anhaengerkupplung-nachruesten/*"} element={<TrailerHitch />} />
        <Route path={"klimaservice/*"} element={<AirConditioning />} />
        <Route path={"raederwechsel/*"} element={<Wheelchange />} />
        <Route path={"bremsfluessigkeit-wechseln/*"} element={<BrakeFluidService />} />
        <Route path={"zuendkerzen-wechseln/*"} element={<SparkPlugService />} />
        <Route path={"termin/*"} element={<Appointment />} />
        {/* catch all */}
        <Route path={"/"} element={<RedirectToCatchAll />} />
        <Route path={"*"} element={<RedirectToCatchAll />} />
      </Route>
    </Routes>
  );
}
